<template>
  <v-col :cols="value.maxLength && value.maxLength > 100 ? 12 : 6">
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: 'AttributeColumn',
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>
